import { render, staticRenderFns } from "./DialogPersonaBonos.vue?vue&type=template&id=f951fd3e&scoped=true&"
import script from "./DialogPersonaBonos.vue?vue&type=script&lang=js&"
export * from "./DialogPersonaBonos.vue?vue&type=script&lang=js&"
import style0 from "./DialogPersonaBonos.vue?vue&type=style&index=0&id=f951fd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f951fd3e",
  null
  
)

export default component.exports